<template>
   <div class="accordion-container pt-3 pb-2 pt-lg-5 pb-lg-5">
      <div class="container container-1200">
         <h2 class="pb-4 pb-lg-5">{{ config.header }}</h2>
         <!-- <p class="text-center" v-html="config.shortDescription[0]" /> -->
         <!-- <div class="row" v-html="getFaqs"></div> -->
         <div class="row">
            <ul class="accordion-content col-12 col-md-6">
               <li v-for="(faq1, index) in getFaqsData.part1" :key="index" class="card border">
                  <div class="card-header" @click="showAnswer">
                     <p>
                        {{ faq1.header }}
                     </p>
                     <span class="arrow-right"></span>
                  </div>
                  <div class="card-body" v-html="faq1.description"></div>
               </li>
            </ul>
            <ul class="accordion-content col-12 col-md-6">
               <li v-for="(faq2, index) in getFaqsData.part2" :key="index" class="card border">
                  <div class="card-header" @click="showAnswer">
                     <p>
                        {{ faq2.header }}
                     </p>
                     <span class="arrow-right"></span>
                  </div>
                  <div class="card-body" v-html="faq2.description"></div>
               </li>
            </ul>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Accordion',
   props: {
      config: {
         type: Object,
         default: () => [],
      },
   },
   computed: {
      getFaqsData() {
         const { body } = this.config;
         const part1 = [];
         const part2 = [];
         body.forEach((item, index) => {
            if (index % 2 === 0) {
               part1.push(item);
            } else {
               part2.push(item);
            }
         });

         return {
            part1,
            part2,
         };
      },
   },
   mounted() {
      this.getAccordionElementHeight();
      this.$nextTick(() => {
         window.addEventListener('resize', this.getAccordionElementHeight);
         window.addEventListener('resize', this.getAccordionElementHeight);
      });
   },
   methods: {
      showAnswer(evt) {
         evt.currentTarget.parentElement.classList.toggle('active');
         if (evt.currentTarget.parentElement.classList.contains('active')) {
            evt.currentTarget.parentElement.style.maxHeight = `${
               evt.currentTarget.parentElement.scrollHeight
            }px`;
         } else {
            evt.currentTarget.parentElement.style.maxHeight = `${evt.currentTarget.scrollHeight}px`;
         }
      },
      getAccordionElementHeight() {
         const initCardHeight = document.querySelectorAll('.accordion-content .card-header');
         for (let i = 0; i < initCardHeight.length; i++) {
            initCardHeight[i].parentElement.classList.remove('active');
            const headerheight = initCardHeight[i].scrollHeight;
            initCardHeight[i].parentElement.style.maxHeight = `${headerheight}px`;
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.accordion-container {
   // background-color: #f9f9fb;

   h2 {
      color: #212344;
      text-align: center;
      margin: 0;
      padding-bottom: 70px;
   }

   .accordion-content {
      .card {
         margin-bottom: 16px;
         transition: max-height 0.25s;
         overflow: hidden;
         .card-header {
            position: relative;
            padding-top: 16px;
            padding-bottom: 16px;
            transition: 0.4s;
            cursor: pointer;
            p {
               margin: 0;
               display: inline-block;
               width: 96%;
               padding-right: 30px;
               line-height: 24px;
               vertical-align: middle;
            }
            .arrow-right {
               cursor: pointer;
               width: 0;
               height: 0;
               border-top: 4.5px solid transparent;
               border-bottom: 4.5px solid transparent;
               border-left: 5px solid #686980;
               opacity: 0.43;
               transition: all 0.2s ease-in;
               display: inline-block;
               vertical-align: middle;
            }
         }
         .card-body {
            padding-top: 0;
            p {
               margin: 0;
               width: 90%;
               color: #686980;
               letter-spacing: 0.25px;
               line-height: 26px;
            }
         }

         &.active {
            .card-header {
               font-weight: 600;
            }
            .arrow-right {
               transform: rotate(90deg);
               transition: all 0.2s ease-in;
            }
         }
      }
   }
}
</style>
